module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100 tw-flex tw-flex-col"
  }, [_c('div', {
    staticClass: "head mb-2 "
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "inp-button blue",
    attrs: {
      "type": "button",
      "title": "Rafraichir la liste",
      "disabled": !_vm.dataReady
    },
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-sync-alt mr-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Rafraichir la liste")])])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "table inp-table noselect tw-m-0"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tbody"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.primoboxExercices), function(exercice) {
    return (_vm.dataReady) ? _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "td cln-periode"
    }, [_vm._v("\n                        " + _vm._s(_vm.formatMoisAnnee(exercice.MoisExercice, exercice.AnneeExercice)) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-debut text-center"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("moment")(exercice.DateDebutExercice, "DD/MM/YY")) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-fin text-center"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("moment")(exercice.DateFinExercice, "DD/MM/YY")) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-nbr text-center"
    }, [_vm._v("\n                        " + _vm._s(exercice.NombreBulletins) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-envoi text-center"
    }, [(exercice.PossedeRedistribution) ? _c('i', {
      staticClass: "fa-solid fa-circle-info tw-text-blue-600 tw-pr-1"
    }) : _vm._e(), _vm._v("\n                        " + _vm._s(_vm._f("moment")(exercice.DateDistribution, "DD/MM/YY - HH:mm:ss")) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-etat text-center"
    }, [(_vm.canShowSimpleEtat(exercice.EtatEnum)) ? _c('div', [_c('span', [_vm._v("\n                                " + _vm._s(_vm.convertEtatToString(exercice.EtatEnum)) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.canShowAnomalieEtat(exercice.EtatEnum)) ? _c('div', [_c('span', {
      staticClass: "tw-text-red-700 fas fa-exclamation-triangle"
    }), _vm._v(" "), _c('a', {
      staticClass: "tw-text-red-700 tw-underline",
      on: {
        "click": function($event) {
          _vm.messageAnomalie()
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.convertEtatToString(exercice.EtatEnum)) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.canShowValiderEtat(exercice.EtatEnum)) ? _c('div', [_c('span', {
      staticClass: "tw-text-orange-600 fas fa-exclamation-circle "
    }), _vm._v(" "), _c('a', {
      staticClass: "tw-text-orange-600 tw-underline",
      on: {
        "click": function($event) {
          _vm.validerDistribution(exercice)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.convertEtatToString(exercice.EtatEnum)) + "\n                            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "td cln-action center-flex"
    }, [(_vm.canShowButtonDistribuer(exercice.EtatEnum)) ? _c('Button', {
      staticClass: "tw-mr-0.5 tw-ml-0.5 tw-w-32",
      attrs: {
        "icon": "fa-solid fa-download",
        "color": "blue",
        "outline": true,
        "disabled": !_vm.canDistribute(exercice),
        "title": 'Distribuer les bulletins dans l\'espace sécurisé des salariés',
        "text": 'Distribuer'
      },
      on: {
        "click": function($event) {
          _vm.openModalDistribuer(exercice)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.canShowButtonDistribuer(exercice.EtatEnum)) ? _c('Button', {
      staticClass: "tw-mr-0.5 tw-ml-0.5 tw-w-32",
      attrs: {
        "icon": "fa-solid fa-eye",
        "color": "blue",
        "outline": true,
        "disabled": !exercice.ExisteTraitementDetails,
        "title": 'Voir le détail des bulletins distribuer',
        "text": 'Voir le détail'
      },
      on: {
        "click": function($event) {
          _vm.openModalDistribuer(exercice)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('Button', {
      staticClass: "tw-mr-0.5 tw-ml-0.5",
      attrs: {
        "icon": "fa-solid fa-sync-alt",
        "color": "green",
        "outline": true,
        "disabled": !_vm.canDistribute(exercice),
        "title": 'Synchronise les salariés avec Primobox',
        "text": 'Synchroniser'
      },
      on: {
        "click": function($event) {
          _vm.synchroniser([])
        }
      }
    })], 1)]) : _c('div', [_c('loader')], 1)
  })], 2)])]), _vm._v(" "), _c('ModalDetailsEnvoiBulletinComponent', {
    ref: "modalDetailsEnvoiBulletinComponent",
    on: {
      "SynchroniserAndDistribuer": _vm.synchroniserAndDistribuer,
      "SynchroniserAndRedistribuer": _vm.synchroniserAndRedistribuer,
      "validerRedistribution": _vm.validerRedistribution
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thead"
  }, [_c('div', {
    staticClass: "tr tw-mr-0 tw-w-[99.1%]"
  }, [_c('div', {
    staticClass: "th cln-periode",
    attrs: {
      "title": "Période de paie"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("PÉRIODE DE PAIE")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-debut",
    attrs: {
      "title": "Date de début de la période"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("DÉBUT")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-fin",
    attrs: {
      "title": "Date de fin de la période"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("FIN")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-nbr",
    attrs: {
      "title": "Date de fin de la période"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("NOMBRE DE BULLETINS")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-envoi",
    attrs: {
      "title": "Date de fin de la période"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("DATE/HEURE DE L'ENVOI")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-etat",
    attrs: {
      "title": "État de l'envoi'"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("ÉTAT DE L'ENVOI")])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-action",
    attrs: {
      "title": "Date de fin de la période"
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("ACTIONS")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-periode"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-debut"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-fin"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-nbr"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-envoi"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-etat"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-action"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6d18cce"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Primobox/envoiBulletins/envoiBulletins.vue.html
// module id = sW2/
// module chunks = 2